import React, {useEffect} from 'react'
import {
    Box,
    Button,
    useStyleConfig,
    Drawer,
    DrawerOverlay,
    DrawerContent,
    DrawerBody,
    useDisclosure,
    Skeleton
} from '@salesforce/retail-react-app/app/components/shared/ui'
import {Global} from '@emotion/react'
import {getConfig} from '@salesforce/pwa-kit-runtime/utils/ssr-config'
import ContentAsset from '../content-asset'

const idMeSkeleton = () => {
    return (
        <Box>
            <Skeleton width="500px" height="210px" margin="0 auto" />
        </Box>
    )
}

export const IdmeButton = () => {
    const IdmeStyles = useStyleConfig('IdmeStyles')

    const {isOpen: isPopoverOpen, onOpen: openPopover, onClose: closePopover} = useDisclosure()

    const {
        app: {commerceAPI}
    } = getConfig()

    const {config} = commerceAPI.idme || {}
    let idmeJSONConfig
    try {
        if (config) {
            idmeJSONConfig = JSON.parse(config)
        }
    } catch (e) {
        console.log(e)
    }

    useEffect(() => {
        if (!isPopoverOpen) return

        const timer = setTimeout(() => {
            if (window.BindIDme) {
                window.BindIDme()
            }
        }, 800)

        return () => clearTimeout(timer)
    }, [isPopoverOpen])

    if (!idmeJSONConfig?.idMeCTA) {
        return null
    }
    return (
        <>
            <Button onClick={() => openPopover()} variant="link" {...IdmeStyles.button}>
                {idmeJSONConfig?.idMeCTA}
            </Button>
            <Box padding="0">
                <Global
                    styles={`
                        idme {
                            margin-bottom: 30px;
                        }
                        .idme__content {
                            max-width: 500px;
                            text-align: center;
                            margin: 0 auto;
                        }
                        .idme__content h2 {
                            font-family: Cormorant;
                            letter-spacing: .005em;
                            color: "black.100";
                            font-size: 27px;
                            line-height: 33px;
                            font-weight: 400;
                            margin-bottom: 10px;
                            @media (min-width: 992px) {
                                font-size: 30px;
                            }
                        }
                        .idme__content p {
                            margin-bottom: 20px;
                            font-family: Inter;
                            letter-spacing: .005em;
                            color: #0a0a0a;
                            font-size: 14px;
                            line-height: 22px;
                            font-weight: 300;
                        }
                        .idme__content span {
                            display: inline-block;
                        }
                    `}
                />
                <Drawer
                    padding="0"
                    placement="bottom"
                    isOpen={isPopoverOpen}
                    onClose={closePopover}
                >
                    <DrawerOverlay />
                    <DrawerContent {...IdmeStyles.drawerContent}>
                        <DrawerBody padding="0">
                            <ContentAsset
                                contentAssetId="idme-popover-content"
                                skeleton={idMeSkeleton}
                            />
                        </DrawerBody>
                    </DrawerContent>
                </Drawer>
            </Box>
        </>
    )
}

IdmeButton.propTypes = {}

export default IdmeButton
